import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const RecVehicleBoatMotorcycleFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4967228' height='680' />
}

export default React.memo(RecVehicleBoatMotorcycleFormBlock)
